import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
import StatusTDModel from './StatusTDModel';
import StatusDocumentModel from './StatusDocumentModel';
export default class ComputeSalaryOutboundModel extends BaseModel {

    constructor() {
        super({ 
                name: "computeSalaryOut",
                tableName: 'document', 
                label: "Danh sách lương văn bản đi tỉnh", 
                display_key: 'code_system', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code_system: {
                name: 'code_system', 
                type: "String",
                label: 'Mã VB hệ thống',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_office_ref: { 
                refs: 'office_tpl {id code name}',
                display: false
            },
            content_document: {
                name: 'content_document', 
                type: "String",
                label: 'Nội dung văn bản',
                width: 15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            name_litigant: {
                name: 'name_litigant', 
                type: "String", 
                label: 'Tên đương sự', 
                sortable: false,
                width: 8,
                class: "center",
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            ward_id: {
                name: 'ward_id', 
                type: "Int",
                label: 'Phường/ xã',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            ward_ref: { 
                refs: 'ward {id name}',
                display: false
            },
            display_ward: { 
                name: "display_ward", 
                label: "Phường / Xã",
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_ward = '';
                    if(data.ward !== undefined && data.ward !== null){
                        data.display_ward = data.ward.name;
                    }
                }
            },
            district_id: {
                name: 'district_id', 
                type: "Int",
                label: 'Quận/ huyện',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            district_ref: { 
                refs: 'district {id name}',
                display: false
            },
            display_district: {
                name: "display_district", 
                label: "Quận / Huyện",
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_district = '';
                    if(data.district !== undefined && data.district !== null){
                        data.display_district = data.district.name;
                    }
                }
            },
            state_id: {
                name: 'state_id', 
                type: "Int",
                label: 'Tỉnh/ thành phố',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            state_ref: { 
                refs: 'state {id name}',
                display: false
            },
            display_state: {
                name: "display_state", 
                label: 'Tỉnh / Thành phố',
                width: 9,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_state = '';
                    if(data.state !== undefined && data.state !== null){
                        data.display_state = data.state.name;
                    }
                }
            },
            code_agency: {
                name: 'code_agency', 
                type: "String",
                label: 'Mã cơ quan',
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            date_receipt_court: {
                name: 'date_receipt_court', 
                type: "Date",
                label: 'Ngày nhận VB từ tòa',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_return_court: {
                name: 'date_return_court', 
                type: "Date",
                label: 'Ngày trả tòa',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            type_document: {
                name: 'type_document', 
                type: "Int",
                label: 'Loại VB',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_tdv_return: {
                name: 'date_tdv_return', 
                type: "Date",
                label: 'Ngày TĐV trả VB',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            tdv_ref: { 
                refs: 'tdv {id fullname}',
                display: false
            },
            display_tdv: {
                name: 'display_tdv', 
                label: 'Họ & tên TĐV',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_tdv = '';
                    if(data.tdv !== undefined && data.tdv !== null){
                        data.display_tdv = data.tdv.fullname;
                    }
                }
            },
            vplk_id: {
                name: 'vplk_id', 
                type: "Int",
                label: 'Văn phòng LK',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            vplk_ref: { 
                refs: 'office_vplk {id name code}',
                display: false
            },
            code_vplk: {
                name: 'code_vplk', 
                label: 'Mã VP liên kết',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.code_vplk = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.code_vplk = data.office_vplk.code;
                    }
                }
            },
            date_tdv_receipt: {
                name: 'date_tdv_receipt', 
                type: "Date",
                label: 'Ngày TĐV nhận VB',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_complete: {
                name: 'date_complete', 
                type: "Date",
                label: 'Ngày TĐ trả',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
            },
            status_td_ref: { 
                refs: 'status_tongdat {id name}',
                display: false
            },
            // status_td_id: {
            //     name: 'status_td_id', 
            //     type: "Selection",
            //     label: 'Hình thức TĐ',
            //     options: [
            //         { value: 1, label: 'Trực tiếp', default: true },
            //         { value: 2, label: 'Trực tiếp (có xác nhận UB)'},
            //         { value: 3, label: 'Giao nhận'},
            //         { value: 4, label: 'Người thứ 3'},
            //         { value: 5, label: 'Người thứ 3 (có xác nhận UB)'},
            //         { value: 6, label: 'Niêm yết'},
            //         { value: 7, label: 'Không thành'},
            //         { value: 8, label: 'Trả lại tòa'}
            //     ],
            //     filter: { 
            //         type: 'select', 
            //         optionLabel: 'label', 
            //         optionKey: 'value', 
            //         match: 'equals' 
            //     },
            //     // display: false
            // },
            status_td_id: { 
                name: "status_td_id", 
                label: "Hình thức TĐ", 
                width: 8,
                class: "center",
                type: "Selection",
                models: new StatusTDModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status_vb_ref: { 
                refs: 'status_document {id name ordinal}',
                display: false
            },
            // status_vb_id: {
            //     name: 'status_vb_id', 
            //     type: "Selection",
            //     label: 'Trạng thái VB',
            //     options: [
            //         { value: 1, label: 'VB chờ xác nhận', default: true },
            //         { value: 2, label: 'VB đã xác nhận'},
            //         { value: 3, label: 'VB đang TĐ'},
            //         { value: 4, label: 'VB đã trả ĐPV'},
            //         { value: 5, label: 'VB ĐPV đã nhận'},
            //         { value: 6, label: 'VB hoàn thiện lại'},
            //         { value: 7, label: 'VB hoàn thành'},
            //         { value: 9, label: 'VB đã trả cơ quan'},
            //         { value: 8, label: 'VB đã tính lương'},
            //     ],
            //     filter: { 
            //         type: 'select', 
            //         optionLabel: 'label', 
            //         optionKey: 'value', 
            //         match: 'equals' 
            //     },
            //     // display: false
            // },
            status_vb_id: { 
                name: "status_vb_id", 
                label: "Trạng thái VB", 
                width: 8,
                class: "center",
                type: "Selection",
                models: new StatusDocumentModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            cost_document: {
                name: 'cost_document', 
                type: "Currency",
                label: 'Giá VB đi tỉnh cơ quan trả',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
            },
            date_comfirm_salary: {
                name: 'date_comfirm_salary',
                type: "Date",
                label: 'Lương tháng',
                width: 10,
                class: "center",
                filter: {type: 'DateRange', match: 'custom'},
                // display: true
            },
            date_upd_salary: {
                name: 'date_upd_salary',
                type: "Date",
                label: 'Ngày xác nhận lương',
                width: 10,
                class: "center",
                filter: {type: 'DateRange', match: 'custom'},
                // display: true
            },
            amount_salary: {
                name: 'amount_salary', 
                type: "InputCurrency",
                label: 'Chi phí tính lương',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
            },
            is_confirm_salary: {
                name: 'is_confirm_salary', 
                type: "Checkbox",
                label: 'Xác nhận tính lương',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
            },
            deadline_color: {
                name: 'deadline_color', 
                type: "Int",
                label: 'Kiểm tra gần hết hạn',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },

        },)
    }

}